/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { i as isWebAp, a as isWebCn } from '../../index-f24a9ec1.js';
import { g as getResumeCallBackData } from '../../common-42e7d8d8.js';
import '../../safe-data-66f20265.js';
import '../../index-6f6b9acc.js';
import '../../_commonjsHelpers-56d33373.js';

/**
 * 监听页面回退事件。
 * 支持【菜鸟、淘宝、支付宝】
 * 注意: 该事件需要和navigateBack API配合触发。
 * @example 使用案例：
 * useEffect(() => {
 *  const callback = () => {}
 *  const cancelGlobalResume = onGlobalResume(callback);
 *
 *  return () => cancelGlobalResume();
}, [])
 * @param cb resume事件回调函数
 * @returns 返回取消全局的global事件
 */
var onGlobalResume = function (cb) {
    var handleResume = function (e) {
        var data = getResumeCallBackData(e);
        cb(data); // 未想到更好方式屏蔽as，此处as作为参数。
    };
    var eventName = 'WV.Event.APP.Active';
    if (isWebAp) {
        eventName = 'resume';
    }
    else if (isWebCn) {
        eventName = 'pageResume';
    }
    document.addEventListener(eventName, handleResume, false);
    return function () { return document.removeEventListener(eventName, handleResume, false); };
};

export { onGlobalResume };
